import { createApp,reactive } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import '../static/css/common.css' //全局修改element-ui
import "../static/iconfont/iconfont.css";
import 'element-plus/dist/index.css'
import '../static/css/element-index.less' //全局修改element-ui
import locale from "element-plus/lib/locale/lang/zh-cn";//需要新加的代码
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app=createApp(App)


// 全局注册el-icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}	
import uniappRequest from './api/axiosconf.js'

app.config.globalProperties.$applicationJson = uniappRequest.applicationJson
app.config.globalProperties.$applicationJsonPrint = uniappRequest.applicationJsonPrint
app.config.globalProperties.$multipartPostImageRecognition = uniappRequest.multipartPostImageRecognition
app.config.globalProperties.$multipartPost = uniappRequest.multipartPost
app.config.globalProperties.$post = uniappRequest.fetchPost
app.config.globalProperties.globalImgPath = uniappRequest.globalImgPath

app.use(ElementPlus, {locale});
app.use(store)
app.use(router)
app.mount('#app')
